import Vue from 'vue'
import fileApi from '@/api/file.api'
import { fileType } from '@/constants'


const state = {
  documents: {}
}


const getters = {
  documents: (state, getters, rootState) => {
    return state.documents[rootState.project.currentId] || []
  },

  documentNames: (state, getters, rootState) => {
    const documents = state.documents[rootState.project.currentId] || []
    const items = documents.map(document => { return document.name })

    return items
  }
}


const actions = {
  async loadDocuments ({ commit, rootState }) {
    const projectId = rootState.project.currentId
    const response = await fileApi.getFiles(rootState.tenant.current, projectId, fileType.document)
    commit('SET_DOCUMENTS', { projectId, documents: response.data })
  },

  async createDocuments ({ commit, rootState }, documents) {
    const projectId = rootState.project.currentId
    const result = []
    for (let i = 0; i < documents.length; i++) {
      const document = documents[i]
      const response = await fileApi.uploadFile(rootState.tenant.current, projectId, fileType.document, document)
      commit('CREATE_DOCUMENT', { projectId, document: response.data })
      result.push(response.data)
    }
    return result
  },

  async updateDocument ({ commit, rootState }, document) {
    const projectId = rootState.project.currentId
    const response = await fileApi.updateFile(rootState.tenant.current, projectId, document.id, document)
    commit('UPDATE_DOCUMENT', { projectId, document: response.data })
  },

  async deleteDocument ({ commit, rootState }, { id }) {
    const projectId = rootState.project.currentId
    await fileApi.deleteFile(rootState.tenant.current, projectId, id)
    commit('DELETE_DOCUMENT', { projectId, id })
  },

  async getDocument ({ commit, rootState }, documentId) {
    const projectId = rootState.project.currentId
    const response = await fileApi.downloadFile(rootState.tenant.current, projectId, documentId)
    return response
  },

  async loadAndUpdateDocument ({ commit, rootState }, entityData) {
    const documentData = { ...entityData }
    documentData.id = entityData.entityId
    const response1 = await fileApi.getFileInfoByFileData(rootState.tenant.current, documentData)
    const projectId = documentData.projectId
    const response = await fileApi.getFiles(rootState.tenant.current, projectId, fileType.document)
    commit('SET_DOCUMENTS', { projectId, documents: response.data })

    return response1
  }
}


const mutations = {
  SET_DOCUMENTS (state, { projectId, documents }) {
    Vue.set(state.documents, projectId, documents)
  },

  CREATE_DOCUMENT (state, { projectId, document }) {
    if (!state.documents[projectId]) {
      Vue.set(state.documents, projectId, [document])
    } else {
      state.documents[projectId].push(document)
    }
  },

  UPDATE_DOCUMENT (state, { projectId, document }) {
    const _document = state.documents[projectId].find(x => x.id === document.id)
    _document.name = document.name
  },

  DELETE_DOCUMENT (state, { projectId, documentId }) {
    const i = state.documents[projectId].findIndex(x => x.id === documentId)
    state.documents[projectId].splice(i, 1)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
